import { apiClient } from "@/api/api-client";
import { truncateName } from "@/api/helper";
import { Form } from "@/components/core/forms/form.tsx";
import { caseStages } from "@/constants/case-stages";
import { caseStagesQueryOptions } from "@/features/case-record/api/queries/case-stage-query";
import CaseStageChart from "@/features/overview/components/case-stage-chart";
import { IconTrendingUp } from "@tabler/icons-react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Line, LineChart, ResponsiveContainer, Tooltip } from "recharts";

export default function CaseStatsModal({ id }: { id: string }) {
	const [counts, setCounts] = useState(0);
	const [statuses, setStatuses] = useState(0);

	const fetchCaseCount = async () => {
		const response = await apiClient.get(`/backoffice/case-records-breakdown/${id}`);
		console.log(response);
		setCounts(response.data.stages);
		setStatuses(response.data.statuses);
	};

	useEffect(() => {
		fetchCaseCount();
	}, []);

	const form = useForm({
		defaultValues: {
			id: 1,
		},
	});

	const caseStageQuery = useSuspenseQuery(caseStagesQueryOptions());
	const caseStagesNew = caseStageQuery.data;

	return (
		<Form {...form}>
			<form className="w-full">
				<div className="flex flex-col w-full">
					<div className="grid grid-cols-12 w-full gap-4">
						{caseStagesNew.data
							.filter((stage) => stage.is_visible === true && stage.order_column !== caseStagesNew.data.length)
							.map((stage, index) => (
								<div key={index} className="col-span-4">
									<div className="flex flex-row w-full min-h-[100px] p-6 gap-3 rounded-md border border-border/50">
										<div className="inline-flex shrink-0 items-center justify-center w-[44px] h-[44px] mt-1 bg-red-50 text-red-600 rounded-full">
											<IconTrendingUp size={24} stroke={1.5} />
										</div>
										<div className="flex flex-col w-full">
											<span className="text-base text-foreground/70">{stage.label}</span>
											<span className="font-bold text-xl text-foreground-dark">
												{stage.order_column === 1 ? (counts[""] ?? 0) + (counts[stage.name] ?? 0) : (counts[stage.name] ?? 0)} Cases
											</span>
										</div>
									</div>
								</div>
							))}
						{/* <div className="col-span-4">
							<div className="flex flex-row w-full min-h-[100px] p-6 gap-3 rounded-md border border-border/50">
								<div className="inline-flex shrink-0 items-center justify-center w-[44px] h-[44px] mt-1 bg-red-50 text-red-600 rounded-full">
									<IconTrendingUp size={24} stroke={1.5} />
								</div>
								<div className="flex flex-col w-full">
									<span className="text-base text-foreground/70">With Appeal</span>
									<span className="font-bold text-xl text-foreground-dark">{statuses.with_appeal ?? 0} Cases</span>
								</div>
							</div>
						</div>
						<div className="col-span-4">
							<div className="flex flex-row w-full min-h-[100px] p-6 gap-3 rounded-md border border-border/50">
								<div className="inline-flex shrink-0 items-center justify-center w-[44px] h-[44px] mt-1 bg-red-50 text-red-600 rounded-full">
									<IconTrendingUp size={24} stroke={1.5} />
								</div>
								<div className="flex flex-col w-full">
									<span className="text-base text-foreground/70">Case Closed</span>
									<span className="font-bold text-xl text-foreground-dark">{statuses.case_closed ?? 0} Cases</span>
								</div>
							</div>
						</div> */}
					</div>
				</div>
			</form>
		</Form>
	);
}
